import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import CircularProgressbar from 'react-circular-progressbar';
import { Progress } from 'react-sweet-progress';
//import "react-sweet-progress/lib/style.css";
// const ReactTooltip = require('react-tooltip');
const UserIdentity = require('../../../helpers/user-identity');
const Actions = require('./actions.js');
const ModalForm = require('./modal-form.jsx');
const LocationSearchInput = require('./auto-complete-form.jsx');
const Store = require('./store');
const ObjectAssign = require('object-assign');
const Async = require('async');
const Config = require('../../../../config.js');

import LotsData from './lot.json';

class LotList extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = Store.getState();
        
        this.params = {
            fopark_url: UserIdentity.apiUrl,
            fopark_key: UserIdentity._checkUserToken()
        };
        
        this.els = {};
        this.updateLotList = this.updateLotList.bind(this);
        this.getLevelsData = this.getLevelsData.bind(this);
        this.levelOptimization = this.levelOptimization.bind(this);
        this.getValueByKey = this.getValueByKey.bind(this);
    }

    updateLotList() {
        
        let url;
        if (UserIdentity._checkUserAddress() !== null) {
            url = `${this.params.fopark_url}/client/lots?name=${Config.get('/client')}&sort_by_location=${parseFloat(UserIdentity._checkUserAddress().lat)},${parseFloat(UserIdentity._checkUserAddress().lng)}`;
        } else {
            url = `${this.params.fopark_url}/client/lots?name=${Config.get('/client')}`;
        }
        fetch(`${url}`, {
            'headers': new Headers({
                'X-api-key':  this.params.fopark_key
            })
        })
            .then(response => response.json())
            .then(
                (result) => {
                    
                    if('lots' in result){
                        
                        this.levelOptimization(result);
                        // this.setState({
                        //     isLoaded: true,
                        //     lots: result.lots,
                        //     error: false
                        // });
                    } else {
                        this.setState({
                            isLoaded: true,
                            error: {
                                'message': 'No Lots Returned'
                            }
                        });
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );
    };

    componentDidMount() {
        
        this.interval = setInterval(this.updateLotList, 15000);
        this.updateLotList();

        this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));
        if (UserIdentity._checkUserAddress() !== null) {
            this.state = this.setState({ selectedAddress : UserIdentity._checkUserAddress()});
        }

    };

    onStoreChange() {

        this.setState(Store.getState());
    }

    componentWillUnmount() {

        this.unsubscribeStore();
        clearInterval(this.interval);

        $('.close-level').collapse({
            toggle: false
        });
    };
    onNewClick(event, lot_name, LatLng, title, percentage, color, lot_status) {
        let address = {};
        
        Actions.showCreateNew(lot_name, address, LatLng, title, percentage, color, lot_status);
    }

    getLevelsData(lotData) {
        
        let lots = lotData['levels'];
        var content = [];
        var _ = this;
        Async.forEach(Object.keys(lots), function (index, callback){ 
            
            let occupied = 0;
            let total = 0;
            let percentage = 0;
            let color = '';
            let isZoneSelected = false;
            let lot = lots[index];

            //lot.status === 1 ? 
            Object.keys(lot.occupancy).map((zone) => {

                let isZoneSelectedTemp = false;
                if (zone !== 'undefined' && zone !== 'all') {
                    isZoneSelectedTemp = localStorage.getItem(`${zone}_selected`);
                
                    if (typeof isZoneSelectedTemp === 'string' && !isZoneSelected) {
                        if (isZoneSelectedTemp === 'false') {
                            isZoneSelected = false;
                        } else {
                            isZoneSelected = true;
                        }
                    }
                    if (isZoneSelectedTemp === null && !isZoneSelected) {
                        isZoneSelected = true;
                    }
                    
                    if (lot.status && ((isZoneSelectedTemp === null) || isZoneSelectedTemp === 'true')) {
                        occupied += lot.occupancy[zone][1];
                        total += lot.occupancy[zone][2] - lot.occupancy[zone][3];
                        percentage = Math.ceil((occupied / total) * 100);
                    }
                    
                }
            });// : null;
            
            let distance_from_location = lot['distance_from_location'] !== undefined ? parseFloat(lot['distance_from_location']).toFixed(2) : 0;

            if (percentage >= 95) {
                color = 'rgb(237, 35, 40)';
            } else if (percentage >= 85 && percentage < 95) {
                color = 'rgb(255, 165, 0)';
            } else {
                color = 'rgb(0, 128, 0)';
            }

            let temp_color = color;
            if (!lot.status) {
                color = '#f77f28';
            }

            if (isZoneSelected) {
                if (!lot.status) {
                    content.push(<div className= "view-wrap" onClick={((e) => _.onNewClick(e, lot['lot_name'], lot['entrance_coords'], lot['title'], percentage, color, lot.status))}>
                        <div className="level-content each_lot" key={`level-content-${lot['lot_name']}`} id={`level-content-${lot['lot_name']}`}>
                        <h6 className="blue" >
                            {lot['title']}
                        </h6>
                        {
                            (distance_from_location !==0 && UserIdentity._checkUserAddress() !== null) ? (
                                <span className="miles"><i className="fa fa-map-marker bounce"></i> {distance_from_location} miles</span>
                            ) : ''
                        }
                        <div className="clearfix"></div>
                        <p className="p-2" style={{ color : '#f77f28', 'textTransform' : 'uppercase'}}>No data available</p>
                        </div>
                    </div>
                    )
                } else {
                    content.push(<div className= "view-wrap" onClick={((e) => _.onNewClick(e, lot['lot_name'], lot['entrance_coords'], lot['title'], percentage, color, lot.status))}><div className="level-content each_lot" key={`level-content-${lot['lot_name']}`} id={`level-content-${lot['lot_name']}`}>
                        <h6 className="blue" >
                            {lot['title']}
                        </h6>
                        {
                            (distance_from_location !==0 && UserIdentity._checkUserAddress() !== null) ? (
                                <span className="miles"><i className="fa fa-map-marker bounce"></i> {distance_from_location} miles</span>
                            ) : ''
                        }
                        
                        <div className="clearfix"></div>
                            {Object.keys(lot.occupancy).sort().map((zone) => {
                                
                                if (zone !== 'undefined' && zone !== 'all') {
                                    let isZoneSelected = localStorage.getItem(`${zone}_selected`);

                                    let zoneColor = 'rgb(211, 170, 23)';
                                    switch(zone){
                                        case 'a':
                                            zoneColor = 'rgb(232, 228, 2)';
                                            break;
                                        case 'b':
                                            zoneColor = 'rgb(69, 255, 25)';
                                            break;
                                        case 'c':
                                            zoneColor = 'rgb(1, 34, 112)';
                                            break;
                                        case 'ada':
                                            zoneColor = 'rgb(18, 90, 214)';
                                            break;
                                        default:
                                            zoneColor = 'rgb(211, 170, 23)';
                                            break;
                                    }

                                    if (typeof isZoneSelected === 'string') {
                                        if (isZoneSelected === 'false') {
                                            isZoneSelected = false;
                                        }
                                        if (isZoneSelected) {
                                            isZoneSelected = true;
                                        }
                                    }
                                    if (isZoneSelected == null) {
                                        isZoneSelected = true;
                                    }
                                    let val = 0;
                                    if (isZoneSelected) {
                                        //val = lot.occupancy[zone][2] - lot.occupancy[zone][1];
                                        val = lot.occupancy[zone][2] - lot.occupancy[zone][1] - lot.occupancy[zone][3];
                                        return (
                                            <div className='p-2'
                                                key={`${lot['api_id']}_${zone}`}>
                                                <span className="color_zone" style={{
                                                    'color': zoneColor
                                                }}>{zone.toUpperCase()}</span>: { val >= 3 ? val : 'Less than 3'}
                                                <span style={{ 'display' : 'none'}}>
                                                    {val}
                                                </span>
                                            </div>
                                        );
                                    }
                                }
                                
                        })}  
                        <div className="lot_progress" key={`level-progress-${lot['lot_name']}`} id={`level-progress-${lot['lot_name']}`}>
                            { (lot.status) ? ( 
                            <Progress
                                type="circle"
                                width={40}
                                percent={percentage}
                                status="active"
                                theme={
                                    {
                                        active: {
                                        symbol: percentage + '%',
                                        trailColor: (percentage >= 96) ? 'white' : 'green',
                                        color: 'red'
                                        },
                                        default: {
                                        symbol: percentage + '%',
                                        trailColor: color,
                                        color: color
                                        },
                                    }
                                    }
                            />
                            ) : '' }
                        </div> 
                    </div>
                    </div>
                    )
                }
            }
            callback(); 
        
        }, function(err) {
            //return content;
        });

        return content;
    }

    levelOptimization(data) {
        
        let lots = data.lots;
        
        var lotArray = [];
        var _ = this;
        Async.forEach(Object.keys(lots), function (index, callback){ 
            
            let site_id = lots[index]['site']['id'];
            //console.log('site_id: ', site_id);

            if (!lotArray[site_id]) {
                lotArray[site_id] = lots[index];
                lotArray[site_id]['levels'] = new Array();
                lotArray[site_id]['levels'].push(lots[index]);
                lotArray[site_id]['levels_title'] = lots[index]['title'];
            } else {
                lotArray[site_id]['levels'].push(lots[index]);
                lotArray[site_id]['levels_title'] = lots[index]['site']['title'];
            }
            
            callback(); 
        
        }, function(err) {
            
            Async.forEach(Object.keys(lotArray), function (lot_index, callback2){ 
                
                if (lotArray[lot_index]['levels'].length === 1) {
                    lotArray[lot_index]['levels'] = [];
                } else {
                    lotArray[lot_index]['levels'] = lotArray[lot_index]['levels'].sort(function(a,b) {return (a.lot_name > b.lot_name) ? 1 : ((b.lot_name > a.lot_name) ? -1 : 0);} );
                }
                callback2(); 
            }, function(err) {
                
                lotArray = lotArray.filter(function(ele, index){
                    return ele;
                });

                //lotArray = lotArray.sort(function(a,b) {return (a.lot_name > b.lot_name) ? 1 : ((b.lot_name > a.lot_name) ? -1 : 0);} );

                
                _.setState({
                    isLoaded: true,
                    lots: lotArray,
                    error: false
                });
            });  

        });  
    }

    async getValueByKey(key, data) {
        var i, len = data.length;
        
        for (i = 0; i < len; i++) {
            if (data[i] && data[i].hasOwnProperty(index)) {
                return data[i][index] === 1;
            }
        }
        
        return -1;
    }

    
    render() {

        const {error, isLoaded, lots} = this.state;
        
        const checkArray  = [];
        if (!isLoaded) {
            
            return (
                <div className="placeholder-content">
                    <h4 className="lot-title">Choose a Lot</h4>
                    <div className="placeholder" style={{'marginTop': '10px'}}>
                        <div className="animated-background"></div>
                    </div>
                    {
                        [...Array(1).keys()].map((val, i) => {
                            return (
                                <div className="placeholder" key={`placeholder_${i}`}>
                                    <div className="animated-background"></div>
                                </div>
                            );
                        })
                    }
                </div>
            );
        } else if (error) {
            
            return <div className="msg_box text-center lot-error">
                <h6 className="msg"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> 
                    Uh Oh! Looks like there is a connection issue. Please try refreshing the app.
                </h6>
                <a onClick={this.updateLotList}><i className="fa fa-refresh" data-tip="Click to refresh lots"></i></a>
               
                {/* <ReactTooltip /> */}
                {/*<p style={{ 'display' : 'none'}}>Error: {error.message}</p>*/}
            </div>;
        } else {
            const lotsToLoad = Config.get('/lot') || [];
            return (
                <div className="content-scroll">
                <div className="lot_box" data-scrollbar>
                    <h4 className="lot-title">Choose a Lot</h4>
                    { (UserIdentity._checkUserAddress() !== null) ? (
                        <span className="my_location"> <strong>Lots near </strong> {UserIdentity._checkUserAddress().address} </span>
                    ) : '' }
                    <div id="lotlink"> 
                    {Object.keys(lots).map((lot) => {
                        
                        let occupied = 0;
                        let total = 0;
                        let percentage = 0;
                        let color = '';
                        let isZoneSelected = false;
                        if (lotsToLoad.indexOf(lots[lot].lot_name) > -1) {
                            Object.keys(lots[lot].occupancy).map((zone) => {
                                // console.log('lot', lots[lot].lot_name, zone);
                                let isZoneSelectedTemp = null;
                                if (zone !== 'undefined' && zone !== 'all') {
                                    if (typeof isZoneSelectedTemp === 'string' && !isZoneSelected) {
                                        if (isZoneSelectedTemp === 'false') {
                                            isZoneSelected = false;
                                        } else {
                                            isZoneSelected = true;
                                        }
                                    }
                                    if (isZoneSelectedTemp === null && !isZoneSelected) {
                                        isZoneSelected = true;
                                    }
                                    
                                    if ((isZoneSelectedTemp === null) || isZoneSelectedTemp === 'true') {
                                        occupied += lots[lot].occupancy[zone][1];
                                        total += lots[lot].occupancy[zone][2] - lots[lot].occupancy[zone][3];
                                        percentage = Math.ceil((occupied / total) * 100);
                                    }
                                }
                            })
                            //}
                            // console.log('occupied1111', occupied);
                            // console.log('total1111', total);
                            
                            if (lots[lot]['levels'].length > 0) {
                                let level_occupied = occupied;
                                let level_total = total;
                                let level_percentage = percentage;
                                let active_level_lots = parseInt(lots[lot]['status']) === 1 ? 1:  0;

                                let tempLevels = lots[lot]['levels'];
                                tempLevels = tempLevels.filter(function(ele, index){
                                    return ele['id'] !== lots[lot]['id'];
                                });
                                
                                Async.forEach(Object.keys(tempLevels), function (index, callback3){ 
                                    
                                    if (tempLevels[index]['status']) {
                                        Object.keys(tempLevels[index].occupancy).map((zone) => {

                                            let isZoneSelectedTemp = false;
                                            if (zone !== 'undefined' && zone !== 'all') {
                                                if (typeof isZoneSelectedTemp === 'string' && !isZoneSelected) {
                                                    if (isZoneSelectedTemp === 'false') {
                                                        isZoneSelected = false;
                                                    } else {
                                                        isZoneSelected = true;
                                                    }
                                                }
                                                if (isZoneSelectedTemp === null && !isZoneSelected) {
                                                    isZoneSelected = true;
                                                }
                                                
                                                if ((isZoneSelectedTemp === null) || isZoneSelectedTemp === 'true') {
                                                    occupied += lots[lot].occupancy[zone][1];
                                                    total += lots[lot].occupancy[zone][2] - lots[lot].occupancy[zone][3];
                                                    percentage = Math.ceil((occupied / total) * 100);
                                                }
                                            }
                                        });
                                    } 
                                    
                                    callback3(); 
                                
                                }, function(err) {
                                    //console.log('occupied2222', level_occupied);
                                    //console.log('total222', level_total);
                                    active_level_lots += 1;
                                    //console.log('level_percentage', level_percentage);
                                    percentage = level_percentage;
                                    //percentage = Math.ceil((percentage + level_percentage) / active_level_lots);
                                });
                                
                            }
                            // isZoneSelected = true; // temp fix
                        } else {
                            isZoneSelected = false
                        }



                        if (percentage >= 95) {
                            color = 'rgb(237, 35, 40)';
                        } else if (percentage >= 85 && percentage < 95) {
                            color = 'rgb(255, 165, 0)';
                        } else {
                            color = 'rgb(0, 128, 0)';
                        }

                        let temp_color = color;
                        if (!lots[lot].status) {
                            color = '#f77f28';
                        }

                        if (isZoneSelected) {
                            checkArray.push(lots[lot]['lot_name']);
                            let distance_from_location = lots[lot]['distance_from_location'] !== undefined ? parseFloat(lots[lot]['distance_from_location']).toFixed(2) : 0;

                            //Popup alteration
                            let popup_lot_name = lots[lot]['lot_name'];
                            let popup_entrance_coords = lots[lot]['entrance_coords'];
                            let popup_title = lots[lot]['title'];
                            let popup_status = lots[lot]['status'];

                            let lotLevelObject = lots[lot]['levels'].filter(function(ele, index){
                                return ele['status'] !== 0;
                            });
                            if (!lots[lot].status && lotLevelObject.length > 0) {
                                let activeLevelObject = lotLevelObject[0];
                                
                                popup_lot_name = activeLevelObject.lot_name;
                                popup_entrance_coords = activeLevelObject.entrance_coords;
                                popup_title = activeLevelObject.title;
                                popup_status = 1;
                                color = temp_color;
                            }

                            return (
                                
                                <a className='lotLink' id={lots[lot]['lot_name']} key={`lot_${lots[lot]['lot_name']}`} role="botton" onClick={ (e) => {lots[lot]['levels'].length > 0 ? null : null}}>
                                    {/* <ReactTooltip /> */}
                                    <div className="media text-muted pt-3">
                                        <div className="media-body pb-3 mb-0 small lh-125">
                                            <div className="w100 each_lot">
                                                <div className="w100">
                                                    <h5 className="blue" onClick={((e) => lots[lot]['levels'].length > 0 ? $('a.close-level[href="#level-box-'+lots[lot]['lot_name']+'"]').click() : this.onNewClick(e, popup_lot_name, popup_entrance_coords, popup_title, percentage, color, popup_status))}>
                                                        {lots[lot]['levels_title']}
                                                    </h5>
                                                    { lots[lot]['levels'].length > 0 ? (
                                                        <div className="d-flex">
                                                            <p className="lot-sub">Open Spaces By Zone</p>
                                                            <a className="close-level collapsed" data-toggle="collapse" href={`#level-box-${lots[lot]['lot_name']}`} aria-expanded="false" aria-controls={`level-box-${lots[lot]['lot_name']}`} >View Levels
                                                                <span className="level-arrow"></span>
                                                            </a>
                                                        </div>
                                                    ) : (!lots[lot].status) ? (
                                                        <div className="d-flex">
                                                            <p className="lot-sub">Open Spaces By Zone</p>
                                                            {
                                                                (distance_from_location !==0 && UserIdentity._checkUserAddress() !== null) ? (
                                                                    <span className="miles"><i className="fa fa-map-marker bounce"></i> {distance_from_location} miles</span>
                                                                ) : ''
                                                            }
                                                            <div className="clearfix"></div>
                                                            <p className="p-2" style={{ color : '#f77f28', 'textTransform' : 'uppercase'}}>No data available</p>

                                                        </div>
                                                    ) : (
                                                        <div className="d-flex">
                                                            <p className="lot-sub">Open Spaces By Zone</p>
                                                            {
                                                                (distance_from_location !==0 && UserIdentity._checkUserAddress() !== null) ? (
                                                                    <span className="miles"><i className="fa fa-map-marker bounce"></i> {distance_from_location} miles</span>
                                                                ) : ''
                                                            }
                                                            <div className="clearfix"></div>
                                                                {Object.keys(lots[lot].occupancy).sort().map((zone) => {
                                                                    
                                                                    if (zone !== 'undefined' && zone !== 'all') {
                                                                        let isZoneSelected = localStorage.getItem(`${zone}_selected`);

                                                                        let zoneColor = 'rgb(211, 170, 23)';
                                                                        switch(zone){
                                                                            case 'a':
                                                                                zoneColor = 'rgb(232, 228, 2)';
                                                                                break;
                                                                            case 'b':
                                                                                zoneColor = 'rgb(69, 255, 25)';
                                                                                break;
                                                                            case 'c':
                                                                                zoneColor = 'rgb(1, 34, 112)';
                                                                                break;
                                                                            case 'ada':
                                                                                zoneColor = 'rgb(18, 90, 214)';
                                                                                break;
                                                                            default:
                                                                                zoneColor = 'rgb(211, 170, 23)';
                                                                                break;
                                                                        }

                                                                        if (typeof isZoneSelected === 'string') {
                                                                            if (isZoneSelected === 'false') {
                                                                                isZoneSelected = false;
                                                                            }
                                                                            if (isZoneSelected) {
                                                                                isZoneSelected = true;
                                                                            }
                                                                        }
                                                                        if (isZoneSelected == null) {
                                                                            isZoneSelected = true;
                                                                        }
                                                                        let val = 0;
                                                                        if (isZoneSelected) {
                                                                            //val = lots[lot].occupancy[zone][2] - lots[lot].occupancy[zone][1];
                                                                            val = lots[lot].occupancy[zone][2] - lots[lot].occupancy[zone][1] - lots[lot].occupancy[zone][3];
                                                                            return (
                                                                                <div className='p-2'
                                                                                     key={`${lots[lot]['api_id']}_${zone}`}>
                                                                                    <span className="color_zone" style={{
                                                                                        'color': zoneColor
                                                                                    }}>{zone.toUpperCase()}</span>: { val >= 3 ? val : 'Less than 3'}
                                                                                    <span style={{ 'display' : 'none'}}>
                                                                                        {val}
                                                                                    </span>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    }
                                                                    return '';
                                                                })}
                                                        </div>
                                                        )}
                                                </div>
                                                <div className="lot_progress">
                                                    { lots[lot]['levels'].length > 0 || (lots[lot].status) ? ( 
                                                    <Progress
                                                      type="circle"
                                                      width={40}
                                                      percent={percentage}
                                                      status="active"
                                                      theme={
                                                            {
                                                              active: {
                                                                symbol: percentage + '%',
                                                                trailColor: (percentage >= 96) ? 'white' : 'green',
                                                                color: 'red'
                                                              },
                                                              default: {
                                                                symbol: percentage + '%',
                                                                trailColor: color,
                                                                color: color
                                                              },
                                                            }
                                                          }
                                                    />
                                                    ) : '' }
                                                </div>
                                                <div className="vehicles" >
                                                    <i className="fa fa-bus" aria-hidden="true" data-tip="Bus hub availabe at the lot"></i>
                                                    <i className="fa fa-bicycle" aria-hidden="true" data-tip="Bike hub availabe at the lot"></i>
                                                    { color === 'rgb(0, 128, 0)' ? 
                                                    (
                                                        <i className="fa fa-thumbs-up" aria-hidden="true" style={{ color : color}}></i>
                                                    ) : (!lots[lot].status) ? ''
                                                        : 
                                                        color == 'rgb(237, 35, 40)' ? 
                                                        (
                                                            <i className="fa fa-thumbs-down" aria-hidden="true" style={{ color : color}}></i>
                                                        ) : ''
                                                    }
                                                    
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        lots[lot]['levels'].length > 0 ? (
                                            <div className="level-wrap collapse" id={`level-box-${lots[lot]['lot_name']}`}>
                                                    {this.getLevelsData(lots[lot])}
                                            </div>
                                        ) : null
                                    }
                                </a>
                                
                            )
                        } 
                        
                        return '';
                    })}
                    </div>
                    {(checkArray.length > 0) ? 
                    (
                        <ModalForm 
                            selected={this.state.selected}
                            {...this.state.createNew}
                        />
                    ) : 
                    (
                        <p className='lotLink text-center' > No lots found!</p>
                    )}
                    
                </div>
                </div>
            );
        }
    };
}

export default LotList;


// WEBPACK FOOTER //
// client/pages/main/lots/LotList.js